import type { LibraryKey } from '../types'

/**
 * Which library each picture on an Internal Library page came from
 * (2026-10-14). That page shows three libraries at once, and a picture's
 * library decides which tags it may be given (long press) and where a report
 * of wrong tags goes. Written as results arrive, read by the tray and the
 * tag dialog. A picture in two libraries keeps the first it was seen in.
 */
const seen = new Map<string, LibraryKey>()

export function noteLibrary(assetId: string, library: LibraryKey): void {
  if (!seen.has(assetId)) seen.set(assetId, library)
}

export function libraryOfAsset(assetId: string): LibraryKey | undefined {
  return seen.get(assetId)
}

/** The pictures by library, for a report (Visual Language too since 2026-10-14). */
export function reportGroups(
  assetIds: string[],
): { library: 'audit' | 'design-works' | 'visual-language'; ids: string[] }[] {
  const by = new Map<'audit' | 'design-works' | 'visual-language', string[]>()
  for (const id of assetIds) {
    const library = seen.get(id)
    if (library === 'audit' || library === 'design-works' || library === 'visual-language') {
      by.set(library, [...(by.get(library) ?? []), id])
    }
  }
  return [...by.entries()].map(([library, ids]) => ({ library, ids }))
}
